import React, {FC, ReactNode} from 'react'
import clsx from 'clsx'

export type SequenceFieldShellProps = {
  label: ReactNode
  control: ReactNode
  meta?: ReactNode
  className?: string
}

/** Normalized label / control / meta bands for sequence half-row fields. */
const SequenceFieldShell: FC<SequenceFieldShellProps> = ({
  label,
  control,
  meta,
  className,
}) => (
  <div className={clsx('channel-sequence-field-shell', className)}>
    <div className='channel-sequence-field-shell__label-band'>{label}</div>
    <div className='channel-sequence-field-shell__control-band'>{control}</div>
    {meta ? <div className='channel-sequence-field-shell__meta-band'>{meta}</div> : null}
  </div>
)

export default SequenceFieldShell
